export enum EmbassadorComissionType {
    PERCENTAGE = 'percentage',
    FIXED = 'fixed'
} 